var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalFavorisRecette",
      attrs: {
        size: "xl",
        title:
          "Favoris de la recette '" +
          _vm.nomRecette +
          "' pour l'ingrédient '" +
          _vm.ingredient.designation +
          "'",
        "ok-title": "Fermer",
        "ok-only": true,
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "ml-1" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2 small" }, [
              _vm._v("Quantité demandée")
            ]),
            _vm.ingredient.produitId
              ? _c("div", { staticClass: "col-10 small" }, [
                  _vm._v("Article sélectionné pour substitution")
                ])
              : _c("div", { staticClass: "col-10 small" }, [
                  _vm._v("Ingrédient sélectionné")
                ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2" }, [
              _c("h5", [
                _vm._v(
                  _vm._s(_vm.ingredient.quantiteBesoinEnUC) +
                    " " +
                    _vm._s(_vm.ingredient.uc)
                )
              ])
            ]),
            _c("div", { staticClass: "col-10" }, [
              _c("h5", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.ingredient.produitId && _vm.ingredient.designation
                        ? _vm.ingredient.designation.toUpperCase()
                        : _vm.nomIngredient.toUpperCase()
                    ) +
                    " " +
                    _vm._s(
                      _vm.ingredient.marque ? " - " + _vm.ingredient.marque : ""
                    ) +
                    " " +
                    _vm._s(
                      _vm.ingredient.fournisseurId
                        ? " - " +
                            _vm.fournisseurNom(_vm.ingredient.fournisseurId)
                        : ""
                    )
                ),
                _c("br"),
                _vm.ingredient.prixUnitaire && _vm.ingredient.uc
                  ? _c("span", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.ingredient.prixUnitaire) +
                          " € / " +
                          _vm._s(_vm.ingredient.uc) +
                          ", prix total: " +
                          _vm._s(
                            _vm._f("afficherPrix")(
                              _vm.ingredient.quantiteBesoinEnUC *
                                _vm.ingredient.prixUnitaire
                            )
                          ) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "flex-start ml-1 mt-3 mb-1 small" }, [
          _vm._v(
            "Articles associés à l'ingrédient \"" +
              _vm._s(_vm.nomIngredient) +
              '"'
          )
        ]),
        _c(
          "div",
          _vm._l(_vm.articlesProduit(_vm.parProduit), function(
            article,
            iArticle
          ) {
            return _c(
              "div",
              {
                key: "article" + iArticle,
                attrs: { id: "accordion" + iArticle }
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-header flex-center-space-between" },
                    [
                      _c("span", [
                        !_vm.mercurialesChargees
                          ? _c("i", {
                              staticClass: "fas fa-spinner fa-spin mr-2"
                            })
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.nomArticle(article.nom)))
                      ]),
                      _c("div", { staticClass: "flex-end" }, [
                        _c(
                          "span",
                          {
                            class: [
                              "pl-3 pr-3 pt-1 pb-1",
                              {
                                meilleurPrixProduitAgap:
                                  _vm.totalPcbMinimal(article.produits) ==
                                  _vm.mieuxDisantGeneral
                              }
                            ],
                            attrs: { "v-tooltip": "Mieux-disant" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("afficherPrix")(
                                  _vm.totalPcbMinimal(article.produits)
                                )
                              )
                            )
                          ]
                        ),
                        _vm.ingredient
                          ? _c(
                              "div",
                              { staticClass: "flex-center-space-between" },
                              [
                                _c("span", { staticClass: "ml-5" }, [
                                  _c("i", {
                                    staticClass: "fa-star cursor-pointer",
                                    class: _vm.articleEnFavori(
                                      _vm.recetteId,
                                      article
                                    )
                                      ? "fas text-warning"
                                      : "far",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changerFavori(
                                          _vm.recetteId,
                                          article
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "card-container" }, [
                    _c("div", { staticClass: "card card-minimal" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-sm table-borderless text-center"
                        },
                        [
                          _c("colgroup", [
                            _c("col"),
                            _c("col", { attrs: { width: "30" } }),
                            _c("col", { attrs: { width: "75" } }),
                            _c("col", { attrs: { width: "160" } }),
                            _c("col", { attrs: { width: "60" } }),
                            _c("col", { attrs: { width: "90" } }),
                            _c("col", { attrs: { width: "90" } }),
                            _c("col", { attrs: { width: "40" } })
                          ]),
                          _c("thead", [
                            _c("th", { staticClass: "aligner-gauche" }, [
                              _vm._v("Désignation")
                            ]),
                            _c("th", [_vm._v("FT")]),
                            _c("th", [_vm._v("Réf.")]),
                            _c("th", [_vm._v("Fournisseur")]),
                            _c("th", [_vm._v("PCB")]),
                            _c("th", [_vm._v("PU HT")]),
                            _c("th", [_vm._v("Total HT")]),
                            _c("th")
                          ])
                        ]
                      ),
                      _c("hr", { staticClass: "mt-0 mb-0" }),
                      _c("div", { staticClass: "table-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-sm table-borderless text-center"
                          },
                          [
                            _c("colgroup", [
                              _c("col"),
                              _c("col", { attrs: { width: "30" } }),
                              _c("col", { attrs: { width: "75" } }),
                              _c("col", { attrs: { width: "160" } }),
                              _c("col", { attrs: { width: "60" } }),
                              _c("col", { attrs: { width: "90" } }),
                              _c("col", { attrs: { width: "90" } }),
                              _c("col", { attrs: { width: "40" } })
                            ]),
                            _c(
                              "tbody",
                              _vm._l(article.produits, function(
                                ligneArticle,
                                iLigne
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: "article" + iLigne,
                                    class: [
                                      {
                                        "ligne-desactivee": ligneArticle.bloque
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "aligner-gauche" },
                                      [
                                        _vm._v(
                                          _vm._s(ligneArticle.designation) +
                                            " - " +
                                            _vm._s(ligneArticle.marque) +
                                            " - " +
                                            _vm._s(ligneArticle.fournisseurId)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      [
                                        ligneArticle.urlFT
                                          ? _c("BoutonFicheTechnique", {
                                              attrs: {
                                                size: "sm",
                                                fournisseurId:
                                                  ligneArticle.fournisseurId,
                                                reference:
                                                  ligneArticle.reference,
                                                urlFT: ligneArticle.urlFT
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c("td", [
                                      _vm._v(_vm._s(ligneArticle.reference))
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fournisseurNom(
                                            ligneArticle.fournisseurId
                                          )
                                        )
                                      )
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(ligneArticle.pcb))
                                    ]),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            "pl-2 pr-2 pt-1 pb-1",
                                            {
                                              meilleurPrixArticleFournisseur:
                                                _vm.prixMinimal(
                                                  article.produits
                                                ) == ligneArticle.prixUnitaire
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("afficherPrix")(
                                                  ligneArticle.prixUnitaire
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            "pl-2 pr-2 pt-1 pb-1",
                                            {
                                              meilleurPrixArticleFournisseur:
                                                _vm.totalPcbMinimal(
                                                  article.produits
                                                ) ==
                                                _vm.totalPcb(
                                                  _vm.ingredient
                                                    .quantiteBesoinEnUC,
                                                  ligneArticle.pcb,
                                                  ligneArticle.prixUnitaire
                                                )
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("afficherPrix")(
                                                  _vm.totalPcb(
                                                    _vm.ingredient
                                                      .quantiteBesoinEnUC,
                                                    ligneArticle.pcb,
                                                    ligneArticle.prixUnitaire
                                                  )
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]),
                                    _c("td", [
                                      _vm.ingredient
                                        ? _c("i", {
                                            staticClass:
                                              "fa-star cursor-pointer",
                                            class: _vm.articleEnFavori(
                                              _vm.recetteId,
                                              article,
                                              ligneArticle
                                            )
                                              ? "fas text-warning"
                                              : "far",
                                            on: {
                                              click: function($event) {
                                                return _vm.changerFavori(
                                                  _vm.recetteId,
                                                  article,
                                                  ligneArticle
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          }),
          0
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }